import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function HungerSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* 两张照片并列展示 */}
      <div className="absolute inset-0 flex">
        {/* 左侧图片 */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={isInView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="relative w-1/2 h-full"
        >
          <BackgroundMedia
            videoSrc={images.hunger1}
            imageSrc={images.hunger1Image}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
        </motion.div>

        {/* 右侧图片 */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={isInView ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="relative w-1/2 h-full"
        >
          <BackgroundMedia
            videoSrc={images.hunger2}
            imageSrc={images.hunger2Image}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
        </motion.div>

        {/* 整体深色遮罩 */}
        <div className="absolute inset-0 bg-black/20" />
      </div>
    </section>
  );
}

